import * as t from "io-ts";
import nullable from "./nullable";
export const shipmentDriverReportColumnT = t.union([
    t.literal("date"),
    t.literal("arrived"),
    t.literal("departed"),
    t.literal("address"),
    t.literal("truck"),
    t.literal("driver"),
    t.literal("note"),
    t.literal("weight"),
    t.literal("volume"),
]);
export const createShipmentDriverReportTemplateTypes = ({ dateTime, }) => {
    const shipmentDriverReportTemplateT = t.strict({
        id: t.string,
        orgId: t.string,
        clientId: nullable(t.string),
        data: t.strict({
            columns: t.array(shipmentDriverReportColumnT),
        }),
        updatedAt: dateTime
    });
    return { shipmentDriverReportTemplateT };
};
export const updateShipmentDriverReportTemplateRequestT = t.strict({
    data: t.strict({
        columns: t.array(shipmentDriverReportColumnT),
    }),
});
//# sourceMappingURL=shipment-driver-report-templates.js.map